import { CommonModule } from '@angular/common';
import { Component, computed, inject, Signal } from '@angular/core';
import { AuthService } from '@webapp/auth/services/auth.service';
import { formatDNI } from '@webapp/core';
import { SortDirection } from '@webapp/core/stores/types';
import {
  BadgeComponent,
  IconComponent,
  Status,
  UserBadgeComponent,
} from '@webapp/ui';
import { isUserType, IUserRow, USER_TYPES } from '../../../interfaces/users.interface';
import { UsersStoreService } from '../../../store/users-store.service';
import { CuitPipe } from '@webapp/core/pipes/cuit.pipe';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-users-table',
  imports: [
    CommonModule,
    RouterLink,
    UserBadgeComponent,
    BadgeComponent,
    IconComponent,
  ],
  providers: [CuitPipe],
  templateUrl: './users-table.component.html',
  styleUrl: './users-table.component.scss',
})
export class UsersTableComponent {
  readonly USER_TYPES = USER_TYPES;
  readonly isUserType = isUserType;
  usersStore = inject(UsersStoreService);
  sortDirection: SortDirection = 'desc';

  authService = inject(AuthService);

  private readonly cuitPipe = inject(CuitPipe);

  canShowProducer = this.authService.isUserNotAgent();
  hasAgentsFilter = this.usersStore.hasAgentsFilter();
  canShowStatus = this.usersStore.hasProspectFilter();

  Status = Status;

   get rows(): Signal<IUserRow[]> {
    return computed(() => {
      const sortMultiplier = this.sortDirection === 'asc' ? 1 : -1;
      return this.usersStore
        .getRows()()
        .sort((a, b) => (a.internalNumber - b.internalNumber) * sortMultiplier);
    });
  }

  toggleSort() {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  }

  formatIdentification(row: IUserRow): string {
    const identification = row.identification;
    if (!identification) return '-';
    const formatted =
      row.type?.toUpperCase() === USER_TYPES.PERSON.toUpperCase()
        ? formatDNI(identification)
        : this.cuitPipe.transform(identification);
    return formatted || identification;
  }
}
